module.exports = __webpack_public_path__ + "img/50.6aaaf2e7.jpg";